export default "__VITE_ASSET__9c96bc84__"